package com.wintermar.inspection.core.ui.component.modal

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.core.ui.component.modal.util.ModalActionModel
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun ConfirmationDialog(
    show: Boolean = false,
    title: String = "",
    message: String = "",
    textAlign: TextAlign = TextAlign.Left,
    action: ModalActionModel = ModalAction.default(),
    onDismiss: () -> Unit
) {
    ModalDialog(
        show = show,
        title = title,
        action = action.copy(
            isSameWeight = true
        ),
        onDismiss = onDismiss
    ) {
        Column(
            modifier = Modifier.padding(LocalAppTheme.current.dimension.spacing.space5)
        ) {
            TextBodyRegular(
                text = message,
                textAlign = textAlign,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}
